module.exports = __webpack_public_path__ + "static/img/2021@2x.03c2993.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/dynamic/newEvents/2021@2x.png
// module id = g+Am
// module chunks = 1